import React from 'react';
import { useRouter } from 'next/router';
import { useBannerActions } from '../../@mrkt/features/Banner';

export function useRouteBanners() {
  const router = useRouter();
  const actions = useBannerActions();
  const { showSuccess, showAnnouncement, hideAll } = actions;

  const onHide = React.useCallback(() => {
    router.push(router.asPath.split('?')[0]);
    return true;
  }, [router]);

  React.useEffect(() => {
    hideAll();
    if (router.query['ra-success'] === 'true') {
      showSuccess(
        "Thanks for your request. We’ll get back to you by email within 3 days. Don't submit another request until you hear from us.",
        {
          compact: true,
          onHide,
        },
      );
    } else if (router.query['jr-success'] === 'true') {
      showSuccess(
        "We've notified your admin. Don't submit another request for this team until you hear back.",
        {
          compact: true,
          onHide,
        },
      );
    } else if (
      router.query.utm_campaign ===
      '2020q2_creator_single_creator_marqueeformredirect'
    ) {
      showSuccess(
        "Thank you for your interest in Marquee! We'll be in touch.",
        {
          compact: true,
          onHide,
        },
      );
    } else if ('sa_ss' in router.query) {
      showAnnouncement(
        <>
          Your Spotify Analytics team is now on Spotify for Artists. If you
          haven’t been invited by email, contact your team admin.{' '}
          <a href="https://artists.spotify.com/blog/S4A-all-together-now">
            Learn more
          </a>
        </>,
        {
          compact: true,
          onHide,
        },
      );
    }
  }, [router, onHide, showAnnouncement, showSuccess]);

  return actions;
}
